import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import styled from 'styled-components';

export const ApplicationContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 960px;
  margin: 20px auto;
  padding: 20px;
`;

export const CustomTable = styled(Table)`
  min-width: 0px;
`;

export const CustomTableHead = styled(TableHead)`
  //background-color: grey;
  font-weight: 800;
  line-height: 0;
  color: white;
`;
